import React from "react";
import { SectionBadge, IconHandshake, Highlight, FadeUp } from "@/components/BrandKit";

const CLIENTS = [
  { name: "Swiggy Instamart", logo: "/brand/logos/instamart-trim.png" },
  { name: "Swiggy Dineout", logo: "/brand/logos/dineout-trim.png" },
  { name: "NOICE!", logo: "/brand/logos/noice-trim.png" },
  { name: "Wipro Chandrika", logo: "/brand/logos/wipro-trim.png" },
  { name: "OB & Gobb", logo: "/brand/logos/obgobb-trim.png" },
  { name: "Dairy Day", logo: "/brand/logos/dairyday-clean.png" },
];

export default function Partners() {
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="border-b border-black bg-[#FDFBF7]"
    >
      <div className="max-w-[1480px] mx-auto px-5 sm:px-8 pt-16 sm:pt-20 pb-20">
        <FadeUp>
          <SectionBadge
            label="Partners"
            num="04"
            color="#48B02C"
            icon={<IconHandshake className="w-4 h-4 text-white" />}
          />
        </FadeUp>
        <FadeUp delay={0.08}>
          <h2
            data-testid="partners-heading"
            className="mt-5 mb-14 font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight"
            style={{ fontWeight: 900 }}
          >
            Creative <Highlight color="#48B02C">collaborators</Highlight>.
          </h2>
        </FadeUp>

        {/* Six equal boxes, logos normalised to the same size */}
        <div
          data-testid="partners-row"
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-5"
        >
          {CLIENTS.map((c, i) => (
            <div
              key={c.name}
              data-testid={`partner-card-${i}`}
              className="group relative flex items-center justify-center h-28 sm:h-32 lg:h-36 border border-black bg-white px-5 py-6 shadow-[5px_5px_0_#000] transition duration-300 hover:-translate-y-1 hover:shadow-[8px_8px_0_#FF4D00]"
              title={c.name}
            >
              <span className="absolute top-1.5 left-2 font-mono text-[9px] uppercase tracking-[0.2em] text-black/35">
                {String(i + 1).padStart(2, "0")}
              </span>
              <img
                src={c.logo}
                alt={c.name}
                className="max-h-full max-w-full object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        <FadeUp delay={0.15}>
          <p
            data-testid="partners-more"
            className="mt-8 text-center font-mono text-[11px] uppercase tracking-[0.3em] text-black/45"
          >
            + and more
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
